export default __webpack_public_path__ + "static/media/news1.8e5c5f08.png";